import { createWebHistory, createRouter } from "vue-router";
import { canActivate } from '@/services/auth-guard.service';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import NoMenuLayout from "@/layouts/NoMenuLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";

const routes = [
    {
        path: "/",
        component: NoMenuLayout,
        children: [
            { path: "", name: "System", meta: { label: "System" }, component: () => import('@/pages/System.vue') },
            { path: "404", name: "404", meta: { label: "404" }, component: () => import('@/pages/404.vue') },
            { path: "login", name: "Login", meta: { label: "Login" }, component: () => import('@/pages/Login.vue') },
            { path: "forgotpassword", name: "ForgotPassword", meta: { label: "Forgot Password" }, component: () => import('@/pages/ForgotPassword.vue') },
            { path: "resetpassword", name: "ResetPassword", meta: { label: "Reset Password" }, component: () => import('@/pages/ResetPassword.vue') },
            {
                path: 'logout',
                name: "Logout",
                beforeEnter(to, from, next) {
                    Cookies.remove("appId");
                    Cookies.remove("token");

                    let baseUrl = process.env.VUE_APP_API_URL ?? '';
                    if (to.query.applicationId && to.query.callbackUrl) {
                        window.location.href = `${baseUrl}/api/authentication/logout?applicationId=${to.query.applicationId}&callbackurl=${to.query.callbackUrl}`;
                    }
                    else {
                        const token = Cookies.get("system");
                        const decoded = jwtDecode(token);

                        Cookies.remove("system");

                        window.location.href = `${baseUrl}/api/authentication/logout?realmId=${decoded.realm}`;
                    }
                }
            },
            {
                path: "init",
                name: "Init",
                component: () => import('@/pages/Init.vue'),
                beforeEnter: (to, from, next) => {
                    next(canActivate())
                }
            },
            {
                path: "changepassword",
                name: "ChangePassword",
                meta: { label: "Change Password" },
                component: () => import('@/pages/ChangePassword.vue'),
            },
        ]
    },
    {
        path: "/main",
        component: MainLayout,
        meta: { mustHaveRealmAccess: true },
        children: [
            { path: "", name: "Main", meta: { label: "Overview" }, component: () => import('@/pages/Main.vue') },
            {
                path: "applications",
                children: [
                    { path: "", name: "Applications", meta: { label: "Applications" }, component: () => import('@/pages/Applications/Manage.vue') },
                    { path: "new", name: "New Application", meta: { label: "Applications" }, component: () => import('@/pages/Applications/New.vue') },
                    { path: "copy/:id", name: "Copy Application", meta: { label: "Copy Application" }, component: () => import('@/pages/Applications/Copy.vue') },                        
                    { path: "edit/:id", name: "Edit Application", meta: { label: "Applications" }, component: () => import('@/pages/Applications/Edit.vue') },
                ]
            },
            {
                path: "users",
                children: [
                    { path: "", name: "Users", meta: { label: "Users" }, component: () => import('@/pages/Users/Manage.vue') },
                    { path: "new", name: "New User", meta: { label: "Users" }, component: () => import('@/pages/Users/New.vue') },
                    { path: "copy/:id", name: "Copy User", meta: { label: "Copy User" }, component: () => import('@/pages/Users/Copy.vue') },
                    { path: "edit/:id", name: "Edit User", meta: { label: "Users" }, component: () => import('@/pages/Users/Edit.vue') },
                ]
            },
            {
                path: "groups",
                children: [
                    { path: "", name: "Groups", meta: { label: "Groups" }, component: () => import('@/pages/Groups/Manage.vue') },
                    { path: "new", name: "New Group", meta: { label: "Groups" }, component: () => import('@/pages/Groups/New.vue') },
                    { path: "edit/:id", name: "Edit Group", meta: { label: "Groups" }, component: () => import('@/pages/Groups/Edit.vue') },
                ]
            },
            { path: "settings", name: "Settings", meta: { label: "Settings" }, component: () => import('@/pages/Settings/Main.vue') },
        ],
        beforeEnter: (to, from, next) => {
            next(canActivate())
        }
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404"
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Browser back/forward buttons
        if (savedPosition) {
            return savedPosition
        }

        // Scroll to top on route change
        return { top: 0 }
    }
});

router.afterEach((to) => {
    const nearestWithLabel = to.matched
        .slice()
        .reverse()
        .find((r) => r.meta?.label);

    document.title = nearestWithLabel
        ? `${nearestWithLabel.meta.label}`
        : 'SSO';
});

export default router;